export const CHECKOUT_URL = 'https://cleaning-ready.impultienda.ar/checkout'
export const PURCHASE_ANCHOR = '#comprar'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/x1SJCYxreAtukL7q8uRWRy/Diseno-sin-titulo-7.webp'

export const insideImages: { src: string; caption: string }[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/d9BYdWmyUx23gwwdp7vPSx/Captura-de-pantalla-2026-09-12-a-la_s_-8.03.21_p._m..png',
    caption: 'New Client Onboarding — Step by Step',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nPzjVQ9HqCL6qEBdMXE8Qv/Captura-de-pantalla-2026-09-12-a-la_s_-8.05.14_p._m..png',
    caption: 'New Client Intake Form',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gyVBfBBDcTETqMVMkts952/Captura-de-pantalla-2026-09-12-a-la_s_-8.04.21_p._m..png',
    caption: 'Booking Request',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7zdBeqZGXzskXTMw1pcBMY/Captura-de-pantalla-2026-09-12-a-la_s_-8.03.54_p._m..png',
    caption: 'New Client Master Checklist',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4xUZuXFT5CtxJRGk6NNYpU/Captura-de-pantalla-2026-09-12-a-la_s_-8.03.01_p._m..png',
    caption: '60-Second New Inquiry Capture',
  },
]

export const systemChecklist = [
  'Client intake & booking forms',
  'Professional cleaning checklists',
  'Quote & pricing tools',
  'Scheduling & job management',
  'Client communication templates',
  'Quality-control resources',
  'Business operations tools',
  'Professional systems ready to use',
]

export interface Module {
  number: number
  title: string
  lines: string[]
  steps: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'CLIENT INTAKE & BOOKING SYSTEM™',
    lines: [
      'Organize every new cleaning client with ready-to-use intake, property, access and booking resources.',
      'Use client profiles, cleaning-needs assessments, service requests, property information and preference forms.',
      'Keep essential client details together instead of searching through scattered messages and notes.',
      'Move from initial inquiry to organized booking with a clear professional workflow.',
    ],
    steps: 'Capture. Organize. Book.',
  },
  {
    number: 2,
    title: 'CLEANING CHECKLIST & SERVICE VAULT™',
    lines: [
      'Access organized cleaning checklists for different properties, rooms and service types.',
      'Use standard, deep-clean, recurring, move-in, move-out, apartment, office and commercial cleaning resources.',
      'Keep room-by-room tasks, final walkthroughs and quality-control steps clearly structured.',
      'Use the appropriate checklist instead of rebuilding your cleaning process for every job.',
    ],
    steps: 'Clean. Check. Verify.',
  },
  {
    number: 3,
    title: 'QUOTE, PRICING & SERVICE SYSTEM™',
    lines: [
      'Organize cleaning estimates, walkthroughs, service scopes and pricing information in one structured system.',
      'Use quote forms, property assessments, labor worksheets, service-scope builders and profitability tools.',
      'Create clearer quotes based on your own services, costs, property information and business requirements.',
      'Stop relying on scattered calculations and improvised estimates.',
    ],
    steps: 'Assess. Calculate. Quote.',
  },
  {
    number: 4,
    title: 'SCHEDULING & JOB MANAGEMENT SYSTEM™',
    lines: [
      'Keep daily jobs, recurring clients, schedules, routes and service changes organized.',
      'Use daily planners, weekly schedules, recurring calendars, job trackers and preparation checklists.',
      'See upcoming, active and completed jobs without relying entirely on memory or disconnected messages.',
      'Keep essential scheduling information visible and easier to manage.',
    ],
    steps: 'Schedule. Prepare. Complete.',
  },
  {
    number: 5,
    title: 'CLIENT COMMUNICATION & RETENTION TOOLKIT™',
    lines: [
      'Communicate professionally throughout every stage of the cleaning client relationship.',
      'Use ready-to-customize messages for inquiries, bookings, reminders, delays, completion, reviews and rebooking.',
      'Keep follow-ups, client communication and recurring-service opportunities organized.',
      'Stop rewriting the same cleaning business messages from scratch.',
    ],
    steps: 'Respond. Confirm. Follow Up.',
  },
  {
    number: 6,
    title: 'BUSINESS OPERATIONS & QUALITY CONTROL SYSTEM™',
    lines: [
      'Standardize important cleaning business operations with practical ready-to-use resources.',
      'Use service standards, SOP templates, quality inspections, incident records, inventory and operational trackers.',
      'Keep job quality, supplies, equipment, team information and business reviews more organized.',
      'Create clearer processes for the operational side of your cleaning business.',
    ],
    steps: 'Standardize. Check. Control.',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  lines: string[]
  steps: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'CLEANING CLIENT FOLLOW-UP PACK™',
    subtitle: 'Ready-to-Use Follow-Up Templates for Leads, Quotes & Past Clients',
    lines: [
      'Keep important cleaning business follow-ups organized with professional ready-to-customize messages.',
      'Use templates for new inquiries, unanswered quotes, previous clients, rebooking and post-service communication.',
      'Stop letting legitimate follow-up opportunities disappear inside scattered conversations.',
    ],
    steps: 'Contact. Follow Up. Record.',
  },
  {
    number: 2,
    title: 'CLEANING SUPPLY & RESTOCK SYSTEM™',
    subtitle: 'Simple Inventory Tools to Keep Every Job Properly Supplied',
    lines: [
      'Organize cleaning supplies, equipment, restocking needs and job-specific preparation in one practical resource.',
      'Use inventory trackers, restock lists, supply-preparation sheets and equipment check tools.',
      'Keep essential supplies easier to review before upcoming cleaning jobs.',
    ],
    steps: 'Check. Prepare. Restock.',
  },
  {
    number: 3,
    title: 'DIFFICULT CLIENT SITUATION RESPONSE KIT™',
    subtitle: 'Professional Scripts for Awkward & Unexpected Cleaning Business Situations',
    lines: [
      'Access professional communication templates for common difficult or unexpected client situations.',
      'Use structured responses for service concerns, extra requests, schedule problems, access issues and disputes.',
      'Respond with clearer communication instead of improvising during stressful situations.',
    ],
    steps: 'Pause. Verify. Respond.',
  },
  {
    number: 4,
    title: 'RECURRING CLIENT CONVERSION KIT™',
    subtitle: 'Tools to Turn One-Time Cleaning Jobs Into Ongoing Service Opportunities',
    lines: [
      'Present recurring cleaning options professionally after appropriate one-time services.',
      'Use weekly, biweekly and monthly service templates, follow-ups and recurring-client setup resources.',
      'Keep recurring-service opportunities organized without relying on aggressive sales tactics.',
    ],
    steps: 'Complete. Confirm. Present.',
  },
  {
    number: 5,
    title: 'CLEANING BUSINESS WEEKLY CONTROL CENTER™',
    subtitle: 'The Complete Weekly Organization System for Cleaning Professionals',
    lines: [
      'Keep jobs, clients, supplies, follow-ups, quotes and weekly priorities visible in one organized system.',
      'Use weekly overviews, job lists, readiness checks, schedule controls and operational review tools.',
      'See what is scheduled, what needs attention and what should happen next.',
    ],
    steps: 'Review. Prepare. Control.',
  },
]

export const differentiators = [
  {
    emoji: '🧹',
    title: 'Ready-to-use professional business resources',
    body: 'Open the system and access organized tools instead of recreating everything from scratch.',
  },
  {
    emoji: '📋',
    title: 'Practical cleaning job organization',
    body: 'Use forms, checklists, trackers and templates to organize everyday cleaning operations.',
  },
  {
    emoji: '🧩',
    title: '6 essential areas in one system',
    body: 'Keep clients, services, quotes, schedules, communication and operations organized.',
  },
  {
    emoji: '🔄',
    title: 'Reusable professional resources',
    body: 'Return to the forms, checklists and business tools whenever you need them.',
  },
  {
    emoji: '📂',
    title: 'Everything in one organized place',
    body: 'Stop relying on scattered notes, messages, documents and improvised systems.',
  },
  {
    emoji: '⏱️',
    title: 'Less repetitive preparation',
    body: 'Spend less time rebuilding the same cleaning business resources every week.',
  },
]

export const offerChecklist = [
  '6 professional modules',
  '5 professional bonuses',
  'Client intake & booking system',
  'Cleaning checklist vault',
  'Quote & pricing tools',
  'Scheduling & job management',
  'Client communication resources',
  'Operations & quality control',
]

export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Sophie Hartley, 34',
    role: 'Independent cleaner · Residential clients',
    location: 'Bristol, United Kingdom',
    quote:
      'I was running everything from WhatsApp and a notebook. Access codes in one chat, the quote in another, the checklist in my head. Now every new client goes through the intake form and the booking request, and I walk in knowing exactly what was agreed. The first week I stopped double-checking three different places before every job.',
  },
  {
    name: 'Dana Kowalski, 41',
    role: 'Owner · Two-person residential cleaning business',
    location: 'Mississauga, Canada',
    quote:
      'Quoting used to be guesswork and I under-priced deep cleans constantly. Using the property assessment and labor worksheet before sending a quote changed that completely. My estimates are consistent now, and when a client asks what is included I have the service scope written down instead of trying to remember.',
  },
  {
    name: 'Tasha Reynolds, 29',
    role: 'Solo cleaner · Move-in and move-out specialist',
    location: 'Charlotte, United States',
    quote:
      'Move-out jobs are where things get missed and where clients complain. The room-by-room checklists and the final walkthrough steps gave me a process I follow the same way every single time. I have not had a callback dispute since I started using the quality-control inspection sheet.',
  },
  {
    name: 'Megan Fitzgerald, 46',
    role: 'Residential cleaning professional · Recurring clients',
    location: 'Newcastle, Australia',
    quote:
      'The communication templates saved my evenings. I used to spend an hour rewriting reminders, delay messages and completion notes. Now I customize a template in two minutes. The follow-up pack also brought back four old clients I had honestly forgotten about.',
  },
  {
    name: 'Claire Mbeki, 38',
    role: 'Small cleaning business owner · Office and commercial',
    location: 'Birmingham, United Kingdom',
    quote:
      'Managing recurring office contracts alongside houses was chaos in my calendar. The weekly control center is now how I start every Monday: jobs, supplies, follow-ups and quotes all in one view. For the first time I can see what needs attention before it becomes a problem.',
  },
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Is this a physical product?',
    a: 'No. CLEANING READY™ is a 100% digital professional resource.',
  },
  {
    q: 'Who is this system for?',
    a: 'Independent cleaners, residential cleaning professionals, solo cleaners and owners of small residential or commercial cleaning businesses looking for organized ready-to-use resources.',
  },
  {
    q: 'Is this cleaning training or a certification?',
    a: 'No. It is a practical cleaning business organization system, not a certification or replacement for required professional training.',
  },
  {
    q: 'Is this another ebook filled with theory?',
    a: 'No. The system focuses on forms, cleaning checklists, quote tools, schedules, communication templates, trackers and ready-to-use operational resources.',
  },
  {
    q: 'Do I have to create the resources myself?',
    a: 'No. The resources are already created and organized. Choose the appropriate tool, customize the relevant details and use it according to your business needs.',
  },
  {
    q: 'What areas are included?',
    a: 'Client Intake & Booking, Cleaning Checklists & Services, Quotes & Pricing, Scheduling & Job Management, Client Communication, and Business Operations & Quality Control.',
  },
  {
    q: 'Can I use the resources for different cleaning services?',
    a: 'Yes. The resources can be adapted according to your cleaning services, clients, properties and business requirements.',
  },
  {
    q: 'Are the resources ready to use?',
    a: 'Yes. They are designed for practical digital use and everyday cleaning business organization.',
  },
  {
    q: 'What additional resources are included?',
    a: 'Five bonuses covering client follow-up, supply and restocking organization, difficult client situations, recurring-service opportunities and weekly business control.',
  },
  {
    q: 'Does this replace professional procedures or business judgment?',
    a: 'No. CLEANING READY™ does not replace professional training, product instructions, safety procedures, business judgment, contracts, insurance requirements or applicable regulations.',
  },
  {
    q: 'How will I receive the product?',
    a: 'You’ll receive immediate digital access after your purchase.',
  },
]

export const purchaseNotifications = [
  { name: 'Emma Whitfield', city: 'Manchester', country: 'United Kingdom' },
  { name: 'Sarah Collins', city: 'Toronto', country: 'Canada' },
  { name: 'Michelle Brennan', city: 'Melbourne', country: 'Australia' },
  { name: 'Linda Carter', city: 'Columbus', country: 'United States' },
  { name: 'Joanne Mackay', city: 'Glasgow', country: 'United Kingdom' },
  { name: 'Rachel Dumont', city: 'Ottawa', country: 'Canada' },
  { name: 'Teresa Novak', city: 'San Antonio', country: 'United States' },
  { name: 'Katrina Boyle', city: 'Brisbane', country: 'Australia' },
  { name: 'Deborah Fields', city: 'Leeds', country: 'United Kingdom' },
  { name: 'Nicole Tremblay', city: 'Calgary', country: 'Canada' },
  { name: 'Angela Ruiz', city: 'Tampa', country: 'United States' },
  { name: 'Fiona Pearce', city: 'Perth', country: 'Australia' },
]
